import "./PageLoader.css";

export default function PageLoader({ title = "Gegevens laden..." }) {
  return (
    <div className="page-loader">
      <div className="page-loader__content">
        <div className="page-loader__logo-wrapper">
          <img src="/Power.png" alt="POWER" className="page-loader__logo" />

          <div className="page-loader__glow" />
        </div>

        <div className="page-loader__dots">
          <span />
          <span />
          <span />
        </div>

        <p className="page-loader__title">{title}</p>
      </div>
    </div>
  );
}
